<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button
      (click)="onCancel()"
      color="secondary"
      fill="outline"
      >
      <ion-icon name="arrow-back" />
      <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
    </ion-button>
  </ion-buttons>

  <ion-title role="heading" aria-level="2">{{ 'TITLE.selectJobs' | translate }}</ion-title>
</ion-toolbar>


<ion-content class="ion-padding">

  <form [formGroup]="form" id="arriveFromGroup" (ngSubmit)="onSubmit()">
    <ion-list>
      @if (!forceAllSelected) {
        <ion-list-header>{{ 'MESSAGE.selectToMarkArrive' | translate }}</ion-list-header>
      }

      @for (re of form.controls; track re) {
        <label>
          <ion-item [formGroup]="re" class="route-event {{ re.controls.routeEvent.value.type }}">
            @if (!forceAllSelected) {
              <input slot="start" class="custom" type="checkbox" formControlName="selected" >
            }
            @if (re.controls.routeEvent.value; as data) {
              <ion-label class="ion-text-wrap" [attr.for]="'checkbox' + i">
                <div>
                  <time>{{ data.headerInfo.time }} </time>
                  <span class="title">{{ data.headerInfo.type | translate }}</span>
                  {{ data.headerInfo.details }}
                </div>
                <app-address [inline]="true" [small]="true" [location]="data.location" />
              </ion-label>
              <div slot="end" class="icons type">
                @for (icon of data.typeIcons; track icon) {
                  @if (icon.svg) {
                    <ion-icon
                      [class]="icon.type"
                      [src]="'assets/icons/' + icon.name + '.svg'"
                      [title]="icon.label | translate"
                      [data-testid]="icon.label"
                      />
                  }
                  @if (!icon.svg) {
                    <ion-icon
                      [class]="icon.type"
                      [name]="icon.name"
                      [title]="icon.label | translate"
                      [data-testid]="icon.label"
                      />
                  }
                }
              </div>
            }
          </ion-item>
        </label>
      }

    </ion-list>
  </form>
</ion-content>

<ion-toolbar class="bottom-actions">
  <ion-button [disabled]="submitting" type="submit" form="arriveFromGroup" color="primary" fill="solid" expand="block">
    <ion-icon name="send" slot="start"></ion-icon>
    <span>{{ 'ACTION.arrive' | translate }}</span>
  </ion-button>
  <ion-button [disabled]="submitting" type="button" fill="outline" expand="block" (click)="onCancel()">
    {{ 'ACTION.cancel' | translate }}
  </ion-button>
</ion-toolbar>
